import { ProductData } from "./types";

export const PRODUCTS: Record<string, string[]> = {
  "URSA PUREFLOC CAVITY": ["Cavity Blown Insulation"],
  "URSA PUREFLOC LOFT 47": ["Loft Blown Insulation"],
  "URSA PUREFLOC UNIVERSAL": [
    "Space Filling Thermal Insulation",
    "Loose Filling Thermal Insulation (20 kg)",
    "Loose Filling Thermal Insulation (15 kg)",
  ],
  "URSA PUREFLOC FRAME": [
    "Frame Filling Thermal Insulation",
    "Loose Filling Thermal Insulation",
  ],
};

export const PRODUCT_DATA: Record<string, Record<string, ProductData>> = {
  "URSA PUREFLOC CAVITY": {
    "Cavity Blown Insulation": {
      bulkDensity: 30,
      thermalCond: 0.034,
      shouldRoundThickness: false,
    },
  },
  "URSA PUREFLOC LOFT 47": {
    "Loft Blown Insulation": {
      bulkDensity: 11,
      thermalCond: 0.047,
      shouldRoundThickness: true,
    },
  },
  "URSA PUREFLOC UNIVERSAL": {
    "Space Filling Thermal Insulation": {
      bulkDensity: 30,
      thermalCond: 0.034,
      shouldRoundThickness: false,
    },
    "Loose Filling Thermal Insulation (20 kg)": {
      bulkDensity: 20,
      thermalCond: 0.036,
      shouldRoundThickness: true,
    },
    "Loose Filling Thermal Insulation (15 kg)": {
      bulkDensity: 15,
      thermalCond: 0.04,
      shouldRoundThickness: false,
    },
  },
  "URSA PUREFLOC FRAME": {
    "Frame Filling Thermal Insulation": {
      bulkDensity: 30,
      thermalCond: 0.034,
      shouldRoundThickness: false,
    },
    "Loose Filling Thermal Insulation": {
      bulkDensity: 20,
      thermalCond: 0.036,
      shouldRoundThickness: true,
    },
  },
};

export const ETEX_CLASSIFICATIONS: Record<string, number> = {
  Architect: 1,
  Contractor: 95,
  Installer: 105,
  Distributor: 22,
  Homeowner: 5,
  Other: 130,
};
